import React, {Component} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {ModalHeader, ModalBody, ModalFooter, Modal, Button} from "reactstrap";
import {addNews} from "../actions";
import LaddaButton, {ZOOM_OUT} from 'react-ladda';
import 'ladda/dist/ladda-themeless.min.css';
import NewsForm from './NewsForm';
import PropTypes from 'prop-types';

class NewsCopyButton extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      updating: false,
      errors: {}
    }

    this.newsForm = React.createRef();
  }

  newsCreate(e, data) {
    e.preventDefault();
    this.setState({creating: true});

    this.props.addNews({
      data: data.news
    }).then(() => {
      this.props.handleChange();
      this.setState({
        creating: false,
        modal: false
      })
    }).catch(e => {
      this.setState({
        creating: false,
        errors: e.response.data.form.errors
      });
    });
  }

  toggleModal(){
    this.setState({
      modal: !this.state.modal
    })
  }

  render() {
    const { updating, errors } = this.state;

    const modal = <Modal isOpen={this.state.modal} toggle={() => this.toggleModal()} size="lg">
      <ModalHeader toggle={() => this.toggleModal()} tag="h2"><FormattedMessage id="admin.newsCopyButton.modalHeader" /></ModalHeader>
      <hr className="my-0" />
      <ModalBody>
        <NewsForm errors={errors} onSubmit={this.newsCreate} ref={this.newsForm} news={this.props.news}/>
      </ModalBody>
      <ModalFooter>
        <FormattedMessage id="_.button.save">{
          (message) => <LaddaButton
            className="btn btn-primary btn-ladda"
            loading={updating}
            data-style={ZOOM_OUT}
            onClick={e => this.newsCreate(e, this.newsForm.current.state)}
          >
            {message}
          </LaddaButton>
        }</FormattedMessage>
        <FormattedMessage id="_.button.cancel">{
          (message) =>
            <Button color="secondary" onClick={() => this.toggleModal()}>{message}</Button>
        }</FormattedMessage>
      </ModalFooter>
    </Modal>;

    return (
      <React.Fragment>
        <Button color="warning" size="sm" onClick={() => this.toggleModal()}><i className="fas fa-clone" /> <FormattedMessage id="_.button.copy"/></Button>
        {modal}
      </React.Fragment>
    )
  }
}

NewsCopyButton.propTypes = {
  news: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired
};

export default connect(null, { addNews }, null, {forwardRef: true})(NewsCopyButton);